import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseTraditionalAntiVirus from '../../AbstractObjects/GatewayPlan/InnerPages/BaseTraditionalAntiVirus';

const pageSchema = PlanGetSchema.pages.traditionalAntiVirus;
const pageId = pageSchema.pageId;

function PlanTraditionalAntiVirus({
    planObject,
    setPlanData
}) {
    const pageData = planObject[pageId];

    return (
        <BaseTraditionalAntiVirus
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanTraditionalAntiVirus;